<template>
  <div>
    <div class="row">
        <div class="col-md-12">
            <div class="row row-spacing">
                <div class="col-md-2">
                    <label>Filter by Status</label>
                    <div class="form-group">
                        <select class="form-control" v-model="statusOptionSelected">
                            <option v-for="opt in statusOptions" :key="opt" :value="opt">{{ opt }}</option>
                        </select>
                    </div>
                </div>
                <div class="col-md-2">
                    <label>Filter by Created</label>
                    <div class="form-group">
                        <select class="form-control" v-model="dateOptionSelected" @change="getAllTickets(dateOptionSelected)">
                            <option v-for="opt in dateOptions" :key="opt.value" :value="opt">{{ opt.label }}</option>
                        </select>
                    </div>
                </div>
                <div class="col-md-6">
                    <label>Search Tickets</label>
                    <div class="form-group">
                        <div class="input-group">
                            <input type="text" class="form-control" placeholder="Search by Ticket Number, Description, User or Agent" v-model="searchTerm">
                            <div class="input-group-append">
                                <span class="input-group-text"><i class="fa fa-search"></i></span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="table-responsive" style="position: relative; z-index: 0;">
      <table class="table table-hover table-bordered">
          <thead style="font-size: 14px; position: relative; z-index: 0;">
              <tr class="dark-row">
                  <th @click="sortBy('ticketNumber')" class="sort-col" style="width: 100px;">
                      Ticket #
                      <i class="fa fa-sort-asc float-right" v-if="sortKey == 'ticketNumber' && reverse"></i>
                      <i class="fa fa-sort-desc float-right" v-if="sortKey == 'ticketNumber' && !reverse"></i>
                  </th>
                  <th @click="sortBy('description')" class="sort-col" style="width: 480px;">
                      Description
                      <i class="fa fa-sort-asc float-right" v-if="sortKey == 'description' && reverse"></i>
                      <i class="fa fa-sort-desc float-right" v-if="sortKey == 'description' && !reverse"></i>
                  </th>
                  <th  @click="sortBy('user')" class="sort-col" style="width: 140px;">
                      User
                      <i class="fa fa-sort-asc float-right" v-if="sortKey == 'user' && reverse"></i>
                      <i class="fa fa-sort-desc float-right" v-if="sortKey == 'user' && !reverse"></i>
                  </th>
                  <th  @click="sortBy('agent')" class="sort-col" style="width: 140px;">
                      Agent
                      <i class="fa fa-sort-asc float-right" v-if="sortKey == 'agent' && reverse"></i>
                      <i class="fa fa-sort-desc float-right" v-if="sortKey == 'agent' && !reverse"></i>
                  </th>
                  <th @click="sortBy('status')" class="sort-col" style="width: 150px">
                      Status
                      <i class="fa fa-sort-asc float-right" v-if="sortKey == 'status' && reverse"></i>
                      <i class="fa fa-sort-desc float-right" v-if="sortKey == 'status' && !reverse"></i>
                  </th>
                  <th  @click="sortBy('created')" class="sort-col" style="width: 100px;">
                      Created
                      <i class="fa fa-sort-asc float-right" v-if="sortKey == 'created' && reverse"></i>
                      <i class="fa fa-sort-desc float-right" v-if="sortKey == 'created' && !reverse"></i>
                  </th>
                  <th  @click="sortBy('lastActionDate')" class="sort-col" style="width: 110px;">
                      Last Action
                      <i class="fa fa-sort-asc float-right" v-if="sortKey == 'lastActionDate' && reverse"></i>
                      <i class="fa fa-sort-desc float-right" v-if="sortKey == 'lastActionDate' && !reverse"></i>
                  </th>
              </tr>
          </thead>
          <tbody v-if="filteredTickets.length > 0 && !loadingTickets" style="font-size: 14px;">
              <tr v-for="ticket in filteredTickets" :key="ticket.ticketNumber" @click="goToHaloTickets(ticket)" v-tooltip="'View ticket in Halo Portal'">
                  <td class="td-pointer">{{ ticket.ticketNumber }}</td>
                  <td class="td-pointer">{{ ticket.description }}</td>
                  <td class="td-pointer">{{ ticket.user }}</td>
                  <td class="td-pointer">{{ ticket.agent }}</td>
                  <td class="td-pointer text-center"><span class="badge" :style="`background-color: ${ticket.colour}; color: ${isDarkColour(ticket.colour) ? '#ffffff' : '#000000'}`">{{ ticket.status }}</span></td>
                  <td class="text-nowrap td-pointer">{{dateFormat(ticket.created)}}</td>
                  <td class="text-nowrap td-pointer">{{dateFormat(ticket.lastActionDate)}}</td>
              </tr>
          </tbody>
          <tbody v-else-if="filteredTickets.length == 0 && !loadingTickets">
              <tr>
                  <td colspan="6">No Halo Tickets to display</td>
              </tr>
          </tbody>
          <tbody v-else>
            <tr>
                <td colspan="6">
                    <DataLoader :loadingText="'Processing Tickets'" />
                </td>
            </tr>
          </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import DataLoader from '@/components/GeneralComponents/DataLoader.vue';
export default {
    components: {
        DataLoader,
    },
  data() {
    return {
        clientNumber: null,
        ticketList: [],
        noReplyTickets: [],
        OldTickets: [],
        statuses: [],
        ticketStatuses: [],
        statusOptions: ["All Tickets", "Open Tickets", "Awaiting Input", "Closed Tickets"],
        statusOptionSelected: "All Tickets",
        dateOptions: [  {label: "Last Month", value: 1}, 
                        {label: "3 Months", value: 3}, 
                        {label: "6 Months", value: 6}, 
                        {label: "1 Year", value: 12}, 
                        {label: "All", value: 0}],
        dateOptionSelected: { label: 'Last Month', value: 1 },
        createdDate: '',
        minDate: '2022-11-01',
        searchTerm: '',
        filteredTicketList: [],
        loadingTickets: false,
        sortKey: 'ticketNumber',
        reverse: false,
    };
  },
  mounted() {
      if (this.userContainsPermission(["CLIENT"])) {
          this.$root.$emit("SET_CLIENT_PAGE_TITLE", 'Halo Tickets'); 
      }
      this.clientNumber = this.$route.params.clientNumber;
      this.getStatuses();
      this.getAllTickets(this.dateOptionSelected);
  },
  computed: {
    filteredTickets() {
        this.filteredTicketList = this.ticketList;
        
        if (this.searchTerm) {                    
            this.filteredTicketList = this.filteredTicketList.filter((ticket) =>                       
                ticket.ticketNumber.toString().includes(this.searchTerm) ||
                ticket.description.toLowerCase().includes(this.searchTerm.toLowerCase()) ||
                ticket.user.toLowerCase().includes(this.searchTerm.toLowerCase()) ||
                ticket.agent.toLowerCase().includes(this.searchTerm.toLowerCase()) 
            );                
        }

        if (this.statusOptionSelected && this.statusOptionSelected !== "All Tickets") {
            this.filteredTicketList = this.filteredTicketList.filter(ticket => {
                const status = ticket.status?.toLowerCase();

                switch (this.statusOptionSelected) {
                case "Open Tickets":
                    return ["new", "in progress", "on hold", "with supplier", "with user"].includes(status);
                case "Awaiting Input":
                    return ["awaiting input", "with user", "action required"].includes(status);
                case "Closed Tickets":
                    return ["closed", "resolved", "completed", "closed item", "closed order"].includes(status);
                default:
                    return true;
                }
            });
        }

        const order = this.reverse ? "asc" : "desc";
        return _.orderBy(this.filteredTicketList, this.sortKey, order);
    }
  },
  methods: {
    getStatuses: function() {
        this.$http.get(`${this.$config.aimsAPIv3}tickets/statuses`).then(
            (response) => {
                this.statuses = response.data;
            },
            (error) => {
                console.error(error);
                this.showError("Error fetching Halo tickets", error);
            }
        );
    },
    getAllTickets: function(option) {
        if (!this.clientNumber) return;

        const monthsBack = option.value;
        const hostUrl = this.$config.aimsAPIv3;

        let url = ``;

        if (monthsBack > 0) {
            url = `${hostUrl}tickets/${this.clientNumber}?since=${monthsBack}`;
        } else {
            url = `${hostUrl}tickets/${this.clientNumber}`;
        }

        this.loadingTickets = true;
        this.$http.get(url).then(
            (response) => {
                this.ticketList = response.data;

                let statusArr = []
                this.ticketList.forEach(ticket => {
                    statusArr.push(ticket.status);
                });    

                let statusSet = new Set(statusArr);
                this.ticketStatuses = [...statusSet];
            },
            (error) => {
                console.error(error);
                this.showError("Error fetching Halo tickets", error);
            }
        ).finally(() => {
            this.loadingTickets = false;
        });
    },
    updateTicketList(data) {
        this.ticketList.push(data);
    },
    sortBy(sortKey) {
        this.reverse = (this.sortKey == sortKey) ? ! this.reverse : false;
        this.sortKey = sortKey;
    },
    goToHaloTickets: function(ticket) { 
        console.log(ticket.url);           
        window.open(ticket.url);
    },
    isDarkColour: function(bgColour) {        
        let color = (bgColour.charAt(0) === '#') ? bgColour.substring(1, 7) : bgColour;        
        let red = parseInt(color.substring(0, 2), 16);
        let green = parseInt(color.substring(2, 4), 16);
        let blue = parseInt(color.substring(4, 6), 16); 
        
        return ((red * 0.299) + (green * 0.587) + (blue * 0.114)) <= 186;
    }
  },
};
</script>

<style scoped>
    .badge {
        border-radius: 3px;
        padding: 8px 10px;
        width: 100%;
    }
</style>

